import React from 'react';
import PropTypes from 'prop-types';
import { Cookies } from 'react-cookie';
import SignUpForm from './SignUpForm';
import LoginForgotForms from './LoginForgotForms';
import CountryProp from '../../../../commonComponents/forms/Address/CountryProp';
import CloseIcon from '../../../shared/icons/CloseIcon';

export default function LoginPhase(props) {
  const {
    cookies,
    languages,
    logo,
    redirectLink,
    onSignUpComplete,
    onClose,
    showRegisterAccount,
    onLoggedIn,
    ignoreRedirection,
  } = props;
  return (
    <div className="login-phase-container">
      <button type="button" onClick={onClose} className="login-modal-close">
        <CloseIcon title="Login close icon" />
      </button>
      <LoginForgotForms
        redirectLink={redirectLink}
        logo={logo}
        onLoggedIn={onLoggedIn}
        ignoreRedirection={ignoreRedirection}
      />
      {showRegisterAccount && (
        <SignUpForm
          languages={languages}
          onSignUpComplete={onSignUpComplete}
          redirectLink={redirectLink}
          cookies={cookies}
        />
      )}
    </div>
  );
}

LoginPhase.propTypes = {
  redirectLink: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  onSignUpComplete: PropTypes.func.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  onClose: PropTypes.func.isRequired,
  showRegisterAccount: PropTypes.bool,
  onLoggedIn: PropTypes.func,
  ignoreRedirection: PropTypes.func,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
};

LoginPhase.defaultProps = {
  showRegisterAccount: true,
  onLoggedIn: null,
  ignoreRedirection: false,
};
